import { FC } from 'react'
import { MonitoringPage } from 'src/reactQuery/useGetMonitoringPagesQuery'
import { CompetitorCard } from './CompetitorCard'
import { CompetitorCardSkeleton } from './CompetitorCard/Skeleton'
import classes from './cards.module.scss'

// .cards is a 3-column grid, so three skeletons fill exactly one row.
const COMPETITOR_SKELETON_COUNT = 3

interface CardsProps {
  isLoading?: boolean
  pages: MonitoringPage[]
}

const formatDate = (iso?: string | null) =>
  iso ? new Date(iso).toLocaleDateString() : ''

export const Cards: FC<CardsProps> = ({ isLoading, pages }) => {
  if (isLoading) {
    return (
      <div className={classes.cards}>
        {Array.from({ length: COMPETITOR_SKELETON_COUNT }).map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <CompetitorCardSkeleton key={index} />
        ))}
      </div>
    )
  }

  return (
    <div className={classes.cards}>
      {pages.map((page) => {
        const snap = page.latest_snapshot ?? null
        const platforms = snap ? Object.keys(snap.platforms ?? {}) : []
        const targetCountries =
          snap?.target_countries?.map((c) => ({
            code: c.code,
            name: c.name,
          })) ?? []
        return (
          <CompetitorCard
            activeAds={snap?.active_count ?? 0}
            addedAt={formatDate(page.created_at)}
            id={page._id}
            key={page._id}
            lastSnapshotAt={page.last_snapshot_at ?? ''}
            logo={
              page.page_picture ||
              `https://graph.facebook.com/${page.page_id}/picture?type=square`
            }
            name={page.page_name || 'Unknown'}
            pageId={page.page_id || ''}
            platforms={platforms.length ? platforms : ['facebook']}
            snapshotStatus={page.snapshot_status ?? null}
            targetCountries={targetCountries}
          />
        )
      })}
    </div>
  )
}
